export const BUTTON_PROPS = {
  size: 40,
  className: "w-40 ml-4",
};

export const PROPENSIO_XID_MODAL_ID = "propensio-xid-modal";
